import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
    // color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    // color: 'currentColor',
    className: null,
};

const PlaySquareIcon = ({ className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="303px"
        height="303px"
        viewBox="0 0 303 303"
        className={classNames([{ [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <polygon
                fill="none"
                stroke="#00E9CC"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                points="151.5,134.8 1.5,68.2 151.5,1.5 301.5,68.2 	"
            />
            <polyline
                fill="none"
                stroke="#00E9CC"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                points="151.5,231.5 151.5,301.5 1.5,234.8 1.5,68.2 151.5,134.8 151.5,201.5 	"
            />
            <polyline
                fill="none"
                stroke="#00E9CC"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                points="151.5,231.5 151.5,301.5 301.5,234.8 301.5,68.2 151.5,134.8 151.5,201.5 	"
            />
        </g>
        <g>
            <path
                fill="#FFFC00"
                d="M127.2,188.6c-3.1,1.6-5.7,0-5.7-3.5v-67.2c0-3.5,2.6-5.1,5.7-3.5l68.6,34.3c3.1,1.6,3.1,4.2,0,5.7
		L127.2,188.6z"
            />
        </g>
        <g>
            <g>
                <path
                    fill="#FFFC00"
                    d="M75.9,210.3l-4.8,11.2h-2.6l-4.8-11.2h2.8l3.4,8l3.5-8H75.9z"
                />
                <path fill="#FFFC00" d="M76.9,210.3h2.6v11.2h-2.6V210.3z" />
                <path
                    fill="#FFFC00"
                    d="M83.2,221.3c-0.8-0.2-1.5-0.6-2-0.9l0.9-2c0.5,0.4,1.1,0.6,1.7,0.8c0.7,0.2,1.3,0.3,2,0.3
			c0.7,0,1.3-0.1,1.6-0.3s0.5-0.5,0.5-0.9c0-0.3-0.1-0.5-0.3-0.7s-0.5-0.3-0.8-0.4s-0.8-0.2-1.3-0.4c-0.9-0.2-1.6-0.4-2.1-0.6
			c-0.5-0.2-1-0.5-1.4-1c-0.4-0.4-0.6-1-0.6-1.8c0-0.7,0.2-1.2,0.5-1.8s0.9-0.9,1.6-1.3c0.7-0.3,1.6-0.5,2.6-0.5
			c0.7,0,1.4,0.1,2.1,0.3s1.3,0.4,1.8,0.7l-0.8,2c-1-0.6-2.1-0.9-3.1-0.9c-0.7,0-1.3,0.1-1.6,0.4c-0.3,0.2-0.5,0.5-0.5,0.9
			s0.2,0.7,0.6,0.9s1,0.4,1.8,0.6c0.9,0.2,1.6,0.4,2.1,0.6c0.5,0.2,1,0.5,1.4,1s0.6,1,0.6,1.8c0,0.6-0.2,1.2-0.5,1.8
			c-0.4,0.5-0.9,0.9-1.6,1.3c-0.7,0.3-1.6,0.5-2.6,0.5C84.9,221.7,84.1,221.6,83.2,221.3z"
                />
                <path fill="#FFFC00" d="M92.3,210.3h2.6v11.2h-2.6V210.3z" />
                <path
                    fill="#FFFC00"
                    d="M99.9,220.9c-0.9-0.5-1.7-1.2-2.2-2.1c-0.5-0.9-0.8-1.9-0.8-3s0.3-2.1,0.8-3c0.5-0.9,1.3-1.6,2.2-2.1
			c0.9-0.5,2-0.8,3.1-0.8c1.2,0,2.2,0.2,3.1,0.8c0.9,0.5,1.7,1.2,2.2,2.1c0.5,0.9,0.8,1.9,0.8,3s-0.3,2.1-0.8,3
			c-0.5,0.9-1.3,1.6-2.2,2.1c-0.9,0.5-2,0.8-3.1,0.8C101.8,221.7,100.8,221.4,99.9,220.9z M104.8,219c0.5-0.3,1-0.7,1.3-1.3
			s0.5-1.2,0.5-1.9s-0.2-1.3-0.5-1.9s-0.7-1-1.3-1.3c-0.5-0.3-1.1-0.5-1.8-0.5c-0.7,0-1.3,0.2-1.8,0.5c-0.5,0.3-1,0.7-1.3,1.3
			c-0.3,0.5-0.5,1.2-0.5,1.9s0.2,1.3,0.5,1.9c0.3,0.5,0.7,1,1.3,1.3c0.5,0.3,1.1,0.5,1.8,0.5C103.7,219.5,104.3,219.3,104.8,219z"
                />
                <path
                    fill="#FFFC00"
                    d="M121.4,210.3v11.2h-2.1l-5.6-6.8v6.8h-2.6v-11.2h2.1l5.6,6.8v-6.8H121.4z"
                />
                <path
                    fill="#FFFC00"
                    d="M134.3,210.3v11.2h-2.1l-5.6-6.8v6.8H124v-11.2h2.1l5.6,6.8v-6.8H134.3z"
                />
                <path
                    fill="#FFFC00"
                    d="M145.6,219.4v2.1h-8.7v-11.2h8.5v2.1h-5.9v2.4h5.2v2h-5.2v2.6H145.6z"
                />
                <path
                    fill="#FFFC00"
                    d="M154.8,221.5l-2.2-3.1h-0.1h-2.3v3.1h-2.6v-11.2h4.8c1,0,1.9,0.2,2.6,0.5c0.7,0.3,1.3,0.8,1.7,1.4
			c0.4,0.6,0.6,1.3,0.6,2.2s-0.2,1.5-0.6,2.2c-0.4,0.6-1,1.1-1.7,1.4l2.5,3.6H154.8z M154.2,212.9c-0.4-0.3-1-0.5-1.8-0.5h-2.1v3.9
			h2.1c0.8,0,1.4-0.2,1.8-0.5c0.4-0.3,0.6-0.8,0.6-1.4C154.8,213.7,154.6,213.3,154.2,212.9z"
                />
                <path fill="#FFFC00" d="M164,210.3h2.6v9.1h5.6v2.1H164V210.3z" />
                <path
                    fill="#FFFC00"
                    d="M181.1,219.1h-5.2l-1,2.4h-2.7l5-11.2h2.6l5,11.2h-2.7L181.1,219.1z M180.3,217.1l-1.8-4.3l-1.8,4.3H180.3z"
                />
                <path
                    fill="#FFFC00"
                    d="M197.9,210.8c0.7,0.3,1.3,0.8,1.7,1.4c0.4,0.6,0.6,1.3,0.6,2.2c0,0.8-0.2,1.5-0.6,2.2c-0.4,0.6-1,1.1-1.7,1.4
			s-1.6,0.5-2.6,0.5h-2.3v3.1h-2.6v-11.2h4.8C196.3,210.3,197.2,210.5,197.9,210.8z M197,215.8c0.4-0.3,0.6-0.8,0.6-1.4
			c0-0.6-0.2-1.1-0.6-1.4s-1-0.5-1.8-0.5h-2.1v3.9h2.1C196,216.3,196.6,216.1,197,215.8z"
                />
                <path fill="#FFFC00" d="M202.1,210.3h2.6v11.2h-2.6V210.3z" />
                <path
                    fill="#FFFC00"
                    d="M216,219.4v2.1h-8.7v-11.2h8.5v2.1h-5.9v2.4h5.2v2h-5.2v2.6H216z M208.2,207.1h2.7l2.2,2.3h-2L208.2,207.1z"
                />
                <path
                    fill="#FFFC00"
                    d="M220.3,220.9c-0.9-0.5-1.6-1.2-2.2-2.1c-0.5-0.9-0.8-1.9-0.8-3s0.3-2.1,0.8-3c0.5-0.9,1.3-1.6,2.2-2.1
			c0.9-0.5,2-0.7,3.1-0.7c1,0,1.8,0.2,2.6,0.5c0.8,0.3,1.4,0.8,2,1.5l-1.7,1.5c-0.8-0.9-1.7-1.3-2.8-1.3c-0.7,0-1.3,0.2-1.9,0.5
			c-0.5,0.3-1,0.7-1.3,1.3c-0.3,0.5-0.5,1.2-0.5,1.9s0.2,1.3,0.5,1.9c0.3,0.5,0.7,1,1.3,1.3c0.5,0.3,1.2,0.5,1.9,0.5
			c1.1,0,2.1-0.4,2.8-1.3l1.7,1.5c-0.5,0.7-1.2,1.1-2,1.5c-0.8,0.3-1.7,0.5-2.6,0.5C222.2,221.7,221.2,221.4,220.3,220.9z"
                />
                <path
                    fill="#FFFC00"
                    d="M238.4,219.4v2.1h-8.7v-11.2h8.5v2.1h-5.9v2.4h5.2v2h-5.2v2.6H238.4z"
                />
            </g>
        </g>
    </svg>
);

PlaySquareIcon.propTypes = propTypes;
PlaySquareIcon.defaultProps = defaultProps;

export default PlaySquareIcon;
